(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactFormly"] = factory(require("react"));
	else
		root["ReactFormly"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports.Formly = __webpack_require__(2);
	module.exports.FieldMixin = __webpack_require__(3);
	module.exports.FormlyConfig = __webpack_require__(1);
	


/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	var fieldTypeMap = {};
	
	module.exports = {
	  fields: {
	    addType: addFieldType,
	    getTypes: getFieldTypes,
	    clearTypes: clearTypes
	  }
	};
	
	function addFieldType(name, field) {
	  if (Array.isArray(name)) {
	    name.forEach(function(fieldType) {
	      addFieldType(fieldType);
	    });
	  } else if (typeof name === 'object') {
	    field = name.field;
	    name = name.name;
	  }
	  fieldTypeMap[name] = field;
	}
	
	function getFieldTypes() {
	  return fieldTypeMap;
	}
	
	function clearTypes() {
	  var oldTypes = fieldTypeMap;
	  fieldTypeMap = {};
	  return oldTypes;
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/** @jsx React.DOM */
	'use strict';
	
	var React = __webpack_require__(4);
	var FormlyConfig = __webpack_require__(1);
	
	function typeOrComponent(props, propName, componentName) {
	  var errorPrefix = componentName + ' config.fields field with key ' + props.key;
	  if (props.type && props.component) {
	    return new Error(errorPrefix + ' should only have either a type or a component, not both.');
	  } else if (!props.type && !props.component) {
	    return new Error(errorPrefix + ' should have either a type (string) or a component (React component)');
	  }
	}
	
	var Formly = React.createClass({displayName: "Formly",
	  propTypes: {
	    onFormlyUpdate: React.PropTypes.func.isRequired,
	    config: React.PropTypes.shape({
	      name: React.PropTypes.string,
	      fields: React.PropTypes.arrayOf(React.PropTypes.shape({
	        key: React.PropTypes.string.isRequired,
	        type: typeOrComponent,
	        component: typeOrComponent,
	        hidden: React.PropTypes.oneOfType([
	          React.PropTypes.bool,
	          React.PropTypes.func
	        ]),
	        props: React.PropTypes.oneOfType([
	          React.PropTypes.object,
	          React.PropTypes.func
	        ]),
	        data: React.PropTypes.object
	      }))
	    }),
	    model: React.PropTypes.object
	  },
	
	  getDefaultProps: function() {
	    return { model: {} };
	  },
	
	  onValueUpdate: function(fieldKey, value) {
	    this.props.model[fieldKey] = value;
	    this.props.onFormlyUpdate(this.props.model);
	  },
	
	  render: function() {
	    var model = this.props.model;
	    var onValueUpdate = this.onValueUpdate;
	    var fields = this.props.config.fields.map(function(field) {
	      return generateFieldTag(field, model, onValueUpdate);
	    });
	    return React.createElement("form", {className: "formly", role: "form", name: this.props.config.name}, fields);
	  }
	});
	
	function generateFieldTag(field, model, onValueUpdate) {
	  var fieldComponent = field.component ? field.component : FormlyConfig.fields.getTypes()[field.type];
	  if (!fieldComponent) {
	    throw new Error('Formly: "' + field.type + '" has not been added to FormlyConfig\'s field types.');
	  }
	
	  if (shouldHide(field, model)) {
	    return null;
	  }
	
	  return getComponent(fieldComponent, field, model, onValueUpdate);
	}
	
	function getComponent(fieldComponent, field, model, onValueUpdate) {
	
	  var componentProps;
	  if (field.props) {
	    componentProps = typeof field.props === 'function' ? field.props(model, field) : field.props;
	  }
	
	  //assign to variable to allow JSX compiler to pick up as a prop instead of string
	  var FieldComponent = fieldComponent;
	  var component = React.createElement(FieldComponent, React.__spread({},  componentProps, {model: model, config: field, onValueUpdate: onValueUpdate, key: field.key}));
	
	  return component;
	}
	
	function shouldHide(field, model) {
	  var hide = isOrInvoke(field, 'hidden', model);
	  return hide && hide !== null;
	}
	
	function isOrInvoke(field, property, model) {
	  if (!field.hasOwnProperty(property)) {
	    return null;
	  }
	  if (typeof field[property] === 'function') {
	    return field[property](model, field);
	  } else {
	    return !!field[property];
	  }
	}
	
	module.exports = Formly;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	var FieldMixin = {
	  onChange: function(event) {
	    var value = getValue(event.target);
	    this.updateValue(value);
	  },
	  updateValue: function(value) {
	    if (this.transformUpdate) {
	      value = this.transformUpdate(value);
	    }
	    this.props.onValueUpdate(this.props.config.key, value);
	  }
	};
	
	function getValue(node) {
	  switch(node.type) {
	    case 'checkbox':
	    case 'radio':
	      return node.checked;
	    case 'select':
	      return node.selected;
	    default:
	      return node.value;
	  }
	}
	
	module.exports = FieldMixin;

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** react-formly.min.js
 **/